import { useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";

const WA_URL = `https://wa.me/917709589870?text=${encodeURIComponent("Hi Nikhil, I'd like to apply for coaching")}`;

export default function FloatingActions() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  const intakeHref = pathname === "/" ? "#intake-form" : "/#intake-form";

  return (
    <>
      <a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Chat with Nikhil on WhatsApp"
        className="fixed right-5 bottom-24 lg:bottom-6 z-[60] flex h-14 w-14 items-center justify-center rounded-full bg-accent text-ink shadow-glow-emerald transition-transform duration-300 hover:scale-110"
      >
        <span className="absolute inset-0 rounded-full bg-accent/50 animate-ping [animation-duration:2.5s]" aria-hidden="true" />
        <span className="relative">
          <MessageCircle className="h-7 w-7" />
        </span>
      </a>
      <div
        className="lg:hidden fixed bottom-0 inset-x-0 z-[60] border-t border-line bg-ink/95 backdrop-blur-xl px-4 py-3"
        data-testid="mobile-sticky-cta-bar"
      >
        <a
          href={intakeHref}
          data-testid="mobile-sticky-cta"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-br from-gold to-gold-dim py-3.5 text-sm font-extrabold uppercase tracking-wide text-ink"
        >
          Apply for 1-on-1 Coaching
        </a>
      </div>
    </>
  );
}